import { BootstrapBreakpoint, useWindowDimensions } from 'hooks/useWindowDimensions';
import { UsePopperOptions } from '@restart/ui/usePopper';
import { Modifier } from '@popperjs/core';

// Popper modifier that forces the dropdown menu to match its toggle's width.
// Used on mobile, where the toggle stretches full-width and a content-sized menu would look disconnected from it.
const sameWidthModifier: Modifier<'sameWidth', Record<string, unknown>> = {
    name: 'sameWidth',
    effect: ({ state }) => {

        const reference = state.elements.reference as HTMLElement;
        state.elements.popper.style.width = `${reference.offsetWidth}px`;

        return () => {

            state.elements.popper.style.width = '';

        };

    },
    enabled: true,
    fn: ({ state }) => {

        state.styles.popper.width = `${state.rects.reference.width}px`;

    },
    phase: 'beforeWrite',
    requires: ['computeStyles']
};

/**
 * Shared Popper config for the table toolbar dropdown menus.
 *
 * `strategy: 'fixed'` lets the menu escape the toolbar/grid `overflow: hidden`
 * clipping. Below the `md` breakpoint the toggles stack full-width, so the
 * `sameWidth` modifier stretches the menu to match; at or above `md` the config
 * is left untouched so the menu sizes to its content.
 */
export const useResponsiveDropdownMenuConfig = (target: BootstrapBreakpoint): UsePopperOptions => {

    const { isBelow } = useWindowDimensions({ target: target || 'sm' });

    return {
        strategy: 'fixed',
        ...(isBelow && { modifiers: [sameWidthModifier] })
    };

};
